import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrganizationStateService {
  private organizationIdSubject = new BehaviorSubject<string | null>(localStorage.getItem('selectedOrganizationId'));
  organizationId$ = this.organizationIdSubject.asObservable();

  setOrganizationId(id: string | null): void {
    this.organizationIdSubject.next(id);

    if (id) {
      localStorage.setItem('selectedOrganizationId', id);
    } else {
      localStorage.removeItem('selectedOrganizationId');
    }
  }

  get currentOrganizationId(): string | null {
    return this.organizationIdSubject.value;
  }
}
